// Mobile device detection utility

let _isMobile: boolean | null = null;

export function isMobile(): boolean {
  if (_isMobile !== null) return _isMobile;
  const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  const smallScreen = window.innerWidth <= 1024 && window.innerHeight <= 1024;
  const mobileUA = /Android|iPhone|iPad|iPod|webOS|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
  // Modern iPadOS reports as macOS Safari but still has touch support
  const isIPadOS = hasTouch && /Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints > 1;
  _isMobile = isIPadOS || (hasTouch && (smallScreen || mobileUA));
  return _isMobile;
}

// Re-evaluate on orientation change (tablet may flip between states)
window.addEventListener('orientationchange', () => {
  _isMobile = null;
});
